import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import {
  getActivities,
  getActivitySummary,
  type ActivityListParams,
} from '../api/activityLog';

export function useActivities(orderUrn: string, params?: Omit<ActivityListParams, 'cursor'>) {
  return useInfiniteQuery({
    queryKey: ['activities', orderUrn, params],
    queryFn: ({ pageParam }) =>
      getActivities(orderUrn, { ...params, cursor: pageParam as string | undefined }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    enabled: !!orderUrn,
  });
}

export function useActivitySummary(orderUrn: string) {
  return useQuery({
    queryKey: ['activities', orderUrn, 'summary'],
    queryFn: () => getActivitySummary(orderUrn),
    enabled: !!orderUrn,
  });
}
